"use strict"

import _ from "lodash"
import angular from "angular"
import moment from "moment"

const kDateFormat = "YYYY-MM-DD"

angular
  .module("uCountitUiApp")

  .controller("StandardExportConfigCtrl", function ($scope, ExportConfigSrv, ApiSrv) {
    $scope.buildHours = {
      options: _.range(1, 24).map((h) => ({
        value: h,
        name: `${h < 10 ? "0" : ""}${h}:00`,
      })),
    }
    $scope.buildHours.selected = $scope.buildHours.options[1]

    $scope.protocols = [
      { value: "sftp", name: "SFTP" },
      { value: "ftp", name: "FTP" },
    ]

    $scope.contents = [
      { name: "Footfall", value: "footfall" },
      { name: "Gender/Age", value: "genderage" },
      { name: "Zone Traffic", value: "zonetraffic" },
      { name: "Flowmap", value: "flowmap" },
      { name: "Heatmap Image", value: "heatmapImg" },
    ]

    $scope.showProtocolsConfig = function (protocol) {
      return $scope.form && $scope.config?.active && $scope.config.protocol === protocol
    }

    $scope.hasPassword = function (protocol) {
      return $scope.originalForm && $scope.originalForm?.standard?.[protocol]?.hasPassword
    }

    $scope.disablePasswordChange = function (protocol) {
      return !$scope.config?.[protocol]?.passwordChange
    }

    $scope.protocol = {
      options: [
        { value: "sftp", name: "SFTP" },
        { value: "ftp", name: "FTP" },
      ],
    }
    $scope.protocol.selected = $scope.protocol.options[0]

    $scope.$watch("protocol.selected", function (protocol) {
      if (protocol && $scope.config) {
        $scope.config.protocol = protocol.value
      }
    })

    $scope.$watch("buildHours.selected", function (hour) {
      if (hour && $scope.config) {
        $scope.config.buildHour = hour.value
      }
    })

    $scope.timezone = ""
    $scope.offset = "+00:00"

    const setLastTimeZone = async function (item) {
      if (!item) {
        $scope.timezone = ""
        $scope.offset = "+00:00"
        return
      }

      const allStores = await ApiSrv.getAllStore({ companyId: item._id, isCache: true })

      const stores = allStores
        .filter((store) => store.orgType === "store")
        .map(function (store) {
          const offset = moment.tz(store.timezone != null ? store.timezone : "UTC").utcOffset()
          store.offset = offset
          return store
        })

      const store = _.minBy(stores, "offset")

      $scope.timezone = store?.timezone || ""
      $scope.offset = store ? moment.tz(store.timezone).format("Z") : "+00:00"
    }

    $scope.$watch("form", function (form) {
      const standardConfig = form.standard
      if (standardConfig) {
        setLastTimeZone($scope.selectedItem)
        setDateTimePicker()

        const buildHourSelected = _.find($scope.buildHours.options, {
          value: standardConfig.buildHour,
        })
        $scope.buildHours.selected = buildHourSelected || $scope.buildHours.options[1]

        const protocolSelected = _.find($scope.protocol.options, { value: standardConfig.protocol })
        $scope.protocol.selected = protocolSelected || $scope.protocol.options[0]

        if (standardConfig?.sftp?.hasPassword) {
          standardConfig.sftp.passwordChange = false
        } else {
          standardConfig.sftp.passwordChange = true
        }
        if (standardConfig?.ftp?.hasPassword) {
          standardConfig.ftp.passwordChange = false
        } else {
          standardConfig.ftp.passwordChange = true
        }
      }

      $scope.config = standardConfig
    })

    $scope.connectionTest = {
      status: "idle", // idle, testing, success, error
      message: "",
    }

    $scope.testConnection = async function () {
      $scope.connectionTest.status = "testing"
      try {
        const result = await ExportConfigSrv.ConnectionTest.test(
          { id: $scope.selectedItem._id, service: "standard-export" },
          $scope.form
        ).$promise
        if (result && result.success) {
          $scope.connectionTest.status = "success"
        } else {
          $scope.connectionTest.status = "error"
          $scope.connectionTest.message = result.message
        }
      } catch (e) {
        $scope.connectionTest.status = "error"
        $scope.connectionTest.message = "Connection failed"
      }
    }

    const setDateTimePicker = function () {
      const options = {
        locale: { format: kDateFormat, applyLabel: "Download" },
        maxDate: moment().endOf("day"),
        autoUpdateInput: false,
        maxSpan: { months: 1 },
      }

      const element = $('#export-config input[name="standard-log-button"]')

      element.daterangepicker2(options)

      element.on("apply.daterangepicker", async (_ev, picker) => {
        const logs = []
        for (let m = moment(picker.startDate); m.isBefore(picker.endDate); m.add(1, "days")) {
          logs.push(
            ...(await ExportConfigSrv.Log.get({
              id: $scope.selectedItem._id,
              service: "standard-export",
              date: m.toISOString(),
            }).$promise)
          )
        }

        const logString = logs
          .map((log) => `${log.createdAt} ${log.level.toUpperCase()} ${log.message}`)
          .join("\n")

        const blob = new Blob([logString], { type: "text/plain;charset=utf-8" })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement("a")
        a.href = url
        a.download = `export_${$scope.selectedItem.name}_build_log(${picker.startDate.format(
          kDateFormat
        )}~${picker.endDate.format(kDateFormat)}).log`
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        window.URL.revokeObjectURL(url)
      })
    }
  })
